import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import createbuild from "../../../assets/img/post/add-pop-thumb.svg";
const ResponseCommunityPopup = (props) => {
  const CommunityName = localStorage.getItem("communityName");
  return (

    <div >
      <Modal show={props.isSucess} onHide={props.CancelPopup} backdrop="static" keyboard={false} dialogClassName="custom-modal modal-dialog-centered">
        <Modal.Header closeButton>
          <div className="popupheader">
            <div className="mod-bor-icon" >
              <img src={createbuild} className="mod-icon"></img>
            </div>
            <div className="header">
              <div className="signuup">Create a new Community</div>
              <p className="Stronger"> Stronger every day, starting today</p>

            </div>
          </div>
        </Modal.Header>

        <Modal.Body className="d-flex align-items-center">

           <div className="succ-content" dangerouslySetInnerHTML={{ __html: `<h4 style="font-size :20px;padding:0px 50px;text-align: center;margin-bottom: 15px;margin-top: 12px;">Your request to start the  ${props.message}  community has been received.</h4><div style=" font-size: 12px;text-align:center;padding:0px 50px;">Our admin team will review your request. You will be notified within 72 hours with the status of your request.</div>` }} /> 


        </Modal.Body>
        <Modal.Footer className="full-w" >

          <button className="next-btn" onClick={props.CancelPopup}>
            OK
          </button>
        </Modal.Footer>

      </Modal>
    </div>
  );

};
export default ResponseCommunityPopup;
